import { NavigateFunction, Location } from "react-router";
import { onVisitProfileAnalytics } from "./analytics";

export const gotoHome = (
  navigate: NavigateFunction,
  location: Location,
  orgPath: string | undefined
): void => {
  navigate({ ...location, pathname: orgPath ? `/${orgPath}` : "/" });
};

export const gotoProfile =
  (navigate: NavigateFunction, location: Location, pathname: string) =>
  (): void => {
    navigate({
      ...location,
      pathname,
    });

    onVisitProfileAnalytics({ pathname });
  };
